import {
	TextHelper,
	//SmallTextHelper,
	//UrlHelper,
	//ArrayHelper
} from '../../PrismicHelpers';

export const bigVideoSlice = data => {
	// Always take the slice_type and return it with data, helper will know what to display/render
	const dataType = data.slice_type;
	// Non repetable data inside slice
	const sliceFixedData = data.primary;
	// Repetable data (example: buttons)
	//const sliceRepetableData = data.items;

	// Data to send to the array of slices (always type and data if needed)
	let dataToSend = {
		type: dataType,
		url: TextHelper(sliceFixedData.wistia_url),
	};
	return dataToSend;
};
export const bigVideoSliceWithCopy = data => {
	// Always take the slice_type and return it with data, helper will know what to display/render
	const dataType = data.slice_type;
	// Non repetable data inside slice
	const sliceFixedData = data.primary;
	// Repetable data (example: buttons)
	//const sliceRepetableData = data.items;

	// Data to send to the array of slices (always type and data if needed)
	let dataToSend = {
		type: dataType,
		url: sliceFixedData.big_video_url,
		copy: sliceFixedData.big_video_copy,
		title: sliceFixedData.big_video_title,
	};
	return dataToSend;
};

export const subtitleSlice = data => {
	// Always take the slice_type and return it with data, helper will know what to display/render
	const dataType = data.slice_type;
	// Non repetable data inside slice
	const sliceFixedData = data.primary;
	// Repetable data (example: buttons)
	//const sliceRepetableData = data.items;

	// Data to send to the array of slices (always type and data if needed)
	let dataToSend = {
		type: dataType,
		text: sliceFixedData.subtitle_text,
	};
	return dataToSend;
};



// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-slice-helpers/single-slice-helpers/bigVideoSlice.js